import { render } from "./PendingInvitesPage.vue?vue&type=template&id=4329e3fa&ts=true"
import script from "./PendingInvitesPage.vue?vue&type=script&lang=ts"
export * from "./PendingInvitesPage.vue?vue&type=script&lang=ts"

import "./PendingInvitesPage.vue?vue&type=style&index=0&id=4329e3fa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__